export const paths = {
  ROOT: "/",
  LOGIN: "/login",
  SIGN_UP: "/signup",
  VERIFY_OTP: "/verify-otp",
  USER_INFO: "/user-info",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  USER_BOOKINGS: "/user-bookings",
  BOOK_SLOT: "/book-slot/:id",
  NOT_FOUND: "/404",
};
